'use client';

import { fetcher } from '@insta-club/api';
import { useBoolean } from '@insta-club/hooks';
import { Guides } from '@insta-club/models';
import useSWR from 'swr';

import HelpButton from '../button/help';
import GuideDialog from './dialog';

interface GuidesButtonProps {
    guideKey: string;
    noModal?: boolean;
    onClick?: (guide: Guides) => void;
    trigger?: React.ReactNode;
}

const GuidesButton: React.FC<GuidesButtonProps> = ({ guideKey, noModal = false, onClick, trigger }) => {
    const { data, isLoading, error } = useSWR<{ data: Guides }>(`/guides/${guideKey}`, (url: string) =>
        fetcher(url, 'web', 'GET')
    );

    const guide = data?.data;
    const dialog = useBoolean();

    if (isLoading || error || !guide) return null;

    const handleOpen = () => {
        if (noModal) {
            onClick?.(guide);
        } else {
            dialog.onTrue();
        }
    };

    return (
        <>
            {trigger ? (
                <div onClick={handleOpen} aria-label='Open guide'>
                    {trigger}
                </div>
            ) : (
                <HelpButton onClick={handleOpen} aria-label='Open guide' />
            )}

            {!noModal && <GuideDialog open={dialog.value} onClose={dialog.onFalse} guide={guide} />}
        </>
    );
};

export default GuidesButton;

